export default "__VITE_ASSET__DqM20HGB__"